let $sliders;

$(document).ready(function($) {

    $sliders = $('.js-slider');
    
    $sliders.each(function (index, value) {

        let slider = $(value).find('.js-slider-main')[0];
        let navContainer = $(value).find('.js-slider-thumbnails')[0];
        let controlsContainer = $(value).find('.js-slider-controls')[0];

        tns({
            container: slider,
            items: 1,
            slideBy: 'page',
            navContainer: navContainer,
            controlsContainer: controlsContainer,
            navAsThumbnails: true,
            mouseDrag: false
        });

        $(slider).on('mouseenter', function() {
            $(this).find('.js-caption').slideUp();
        })

        $(slider).on('mouseleave', function() {
            $(this).find('.js-caption').slideDown();
        })
    });

});
